module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-right-185b39664bbe73347092d6df8043e3c9.svg";